import { render } from "./CheckBoxSelectPair.vue?vue&type=template&id=a3d95c94&scoped=true"
import script from "./CheckBoxSelectPair.vue?vue&type=script&lang=js"
export * from "./CheckBoxSelectPair.vue?vue&type=script&lang=js"

import "./CheckBoxSelectPair.vue?vue&type=style&index=0&id=a3d95c94&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d95c94"]])

export default __exports__